export const AVAILABLE_GROUP_SIZES = [5, 10, 20] as const;
export type GroupSize = (typeof AVAILABLE_GROUP_SIZES)[number];
